import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that highlights matching substring within a string by wrapping matches with a mark.
 * Supports multiple search terms separated by spaces.
 *
 * @example
 * ```html
 * <p [innerHTML]="'Harbitzalléen 5' | highlightSearch:'harbitz 5'"></p>
 * <!-- Output: <mark class="background--brand-accent">Harbitz</mark>alléen <mark class="background--brand-accent">5</mark> -->
 * ```
 */
@Pipe({
  name: 'highlightSearch',
})
export class HighlightSearchPipe implements PipeTransform {
  transform(text: string | null | undefined, searchQuery: string | null | undefined) {
    if (!text || !searchQuery || searchQuery.trim() === '') {
      return text ?? '';
    }

    const searchTerms = searchQuery.split(/\s+/g).filter(term => term.length);

    if (!searchTerms.length) {
      return text;
    }

    const escapedTerms = searchTerms.map(term => term.replace(/[.*+?^${}()|[\]\\]/g, ''));

    const regex = new RegExp(`(${escapedTerms.join('|')})`, 'gi');

    const result = text.replace(regex, `<mark class="background--brand-accent">$1</mark>`);

    return result;
  }
}
